/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertNotificationSetting } from '../../models/alert-notification-setting';
import { AlertNotificationSettingDto } from '../../models/alert-notification-setting-dto';

export interface UpdateSetting_4$Params {
  settingId: number;
      body: AlertNotificationSettingDto
}

export function updateSetting_4(http: HttpClient, rootUrl: string, params: UpdateSetting_4$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, updateSetting_4.PATH, 'put');
  if (params) {
    rb.path('settingId', params.settingId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlertNotificationSetting>;
    })
  );
}

updateSetting_4.PATH = '/api/notification/alert/setting/{settingId}';
